export default __webpack_public_path__ + "static/media/xcRMRK.ba08b0f7.png";